/** Journey rank for board lane ordering (ocean default columns + air extras). */
export const SHIPMENT_STATUS_RANK = {
  "Seller Location": 0,
  "Partially Gate In at Loading Port": 1,
  "Gate In at Loading Port": 1,
  "Partially Accepted by Carrier": 1,
  "Accepted by Carrier": 1,
  "Partially Loaded at Loading Port": 2,
  "Loaded at Loading Port": 2,
  "Partially Manifested": 2,
  "Manifested": 2,
  "Partially Departed Loading Port": 3,
  "Departed Loading Port": 3,
  "Partially Departed": 3,
  "Departed": 3,
  "Partially Transshipment": 4,
  "Transshipment": 4,
  "Partially Arrived at Discharge Port": 5,
  "Arrived at Discharge Port": 5,
  "Partially Arrived": 5,
  "Arrived": 5,
  "Partially Discharged": 6,
  "Discharged": 6,
  "Partially Received from Flight": 6,
  "Received from Flight": 6,
  "Partially Gate Out at Discharge Port": 7,
  "Gate Out at Discharge Port": 7,
  "Partially Released": 7,
  "Released": 7,
  "Partially Final Destination": 8,
  "Final Destination": 8,
  "Partially ASN Validated": 9,
  "ASN Validated": 9,
  "Partially ASN Created": 10,
  "ASN Created": 10,
  "Partial Receipt Created": 11,
  "Full Receipt Created": 12,
  Completed: 13,
  Closed: 14,
  Cancelled: 15,
};

export const DEFAULT_SHIPMENT_STATUS_LANE_ORDER = [
  "Seller Location",
  "Partially Gate In at Loading Port",
  "Gate In at Loading Port",
  "Partially Loaded at Loading Port",
  "Loaded at Loading Port",
  "Partially Departed Loading Port",
  "Departed Loading Port",
  "Partially Transshipment",
  "Transshipment",
  "Partially Arrived at Discharge Port",
  "Arrived at Discharge Port",
  "Partially Discharged",
  "Discharged",
  "Partially Gate Out at Discharge Port",
  "Gate Out at Discharge Port",
  "Partially Final Destination",
  "Final Destination",
  "Partially ASN Validated",
  "ASN Validated",
  "Partially ASN Created",
  "ASN Created",
  "Partial Receipt Created",
  "Full Receipt Created",
  "Completed",
  "Closed",
  "Cancelled",
];

const defaultLaneSet = new Set(DEFAULT_SHIPMENT_STATUS_LANE_ORDER);

export function extraShipmentStatusLanesFromOrders(orders = []) {
  const extras = new Set();
  orders.forEach(order => {
    const status = order?.status;
    if (status && !defaultLaneSet.has(status)) {
      extras.add(status);
    }
  });
  return [...extras].sort(
    (a, b) =>
      (SHIPMENT_STATUS_RANK[a] ?? Number.MAX_SAFE_INTEGER) -
      (SHIPMENT_STATUS_RANK[b] ?? Number.MAX_SAFE_INTEGER)
  );
}

export function defaultShipmentStatusBoardColumns(orders = []) {
  return [...DEFAULT_SHIPMENT_STATUS_LANE_ORDER, ...extraShipmentStatusLanesFromOrders(orders)];
}

export function groupShipmentsByStatusLanes(orders = [], columnOrder = []) {
  const groups = {};
  columnOrder.forEach(status => {
    groups[status] = [];
  });
  orders.forEach(order => {
    const status = order?.status;
    if (status) {
      if (!groups[status]) {
        groups[status] = [];
      }
      groups[status].push(order);
    }
  });
  return groups;
}
